import { useQuery } from '@tanstack/react-query'
import { weeklyApi } from '../../api/weekly'
import { useSpoke } from '../../hooks/useSpoke'
import { formatDate, formatMoney } from '../../lib/format'
import { weekLabel } from '../../lib/weekly'

// Previous weeks' updates, as written: the headline, the numbers as they stood, and whether a model wrote it.
// Click a week to read it in full above.
export function HistoryPanel({ currentWeek, onPick }: { currentWeek: string; onPick: (weekStart: string) => void }) {
  const spoke = useSpoke()
  const q = useQuery({ queryKey: ['weekly-history', spoke], queryFn: () => weeklyApi.history(spoke), staleTime: 15_000 })
  if (!q.isSuccess) return null
  const list = q.data
  return (
    <details className="card history-card weekly-history" open={list.length > 0 && list.length <= 3}>
      <summary><h2>History</h2><span className="muted">{list.length} week{list.length === 1 ? '' : 's'} written</span></summary>
      {list.length === 0 && <p className="muted">No week written yet. The first one becomes the baseline the next week's movement is measured against.</p>}
      <ul className="plain history-weeks">
        {list.map((u) => (
          <li key={u.weeklyUpdateId} className={u.weekStart === currentWeek ? 'current' : ''}>
            <button className="link-button history-week" onClick={() => onPick(u.weekStart)}>
              <strong>Week of {weekLabel({ start: u.weekStart, end: u.weekEnd })}</strong>
              <span className="history-headline">{u.headline || '(no headline)'}</span>
            </button>
            <span className="history-meta">
              {u.glance && <span className="muted small">{u.glance.newPursuits} new · {u.glance.stageUps} up · {u.glance.stageDowns} down · {u.glance.meetingsHeld} meetings · {formatMoney(u.glance.pipelineNow)} named</span>}
              <span className="muted small">{u.words} words · {u.cited} cited · {formatDate(u.writtenAt)}</span>
              {u.modelWritten ? <span className="tag live">model-written</span> : <span className="tag">laid out</span>}
            </span>
          </li>
        ))}
      </ul>
    </details>
  )
}
